<div class="flex-container">
  <div style="flex: 12">
    <mat-form-field >
      <mat-icon svgIcon="basics:search" matPrefix></mat-icon>
      <input
        matInput
        [formControl]="searchInputControl"
        placeholder="{{'registrierung.adress-suche.placeholder'|translate}}" />
    </mat-form-field>
  </div>
</div>
@if (searchResult().length > 0) {
  <div class="results-list-container">
    @for (osmAdresse of searchResult(); track (osmAdresse.lat + '-' + osmAdresse.lon)) {
      @if(osmAdresse) {
          <div class="adress-treffer" (click)='onSelectAdresse(osmAdresse)'>{{osmAdresse.display_name}}</div>
      }
    }
  </div>
}


